
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/payment-policy",
      function () {
        return require("private-next-pages/article/payment-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/payment-policy"])
      });
    }
  